var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNySnowman(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 96,
    viewBox: "0 0 168 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_901_6009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.998 90.9453H165.453V93.4722H167.998V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.455 90.9453H162.91V93.4722H165.455V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.909 93.4727H160.363V95.9988H162.909V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.909 90.9453H160.363V93.4722H162.909V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.362 93.4727H157.816V95.9988H160.362V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.362 90.9453H157.816V93.4722H160.362V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.362 88.4219H157.816V90.948H160.362V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.819 93.4727H155.273V95.9988H157.819V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.819 90.9453H155.273V93.4722H157.819V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.819 88.4219H155.273V90.948H157.819V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.273 93.4727H152.727V95.9988H155.273V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.273 90.9453H152.727V93.4722H155.273V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.273 88.4219H152.727V90.948H155.273V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.729 93.4727H150.184V95.9988H152.729V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.729 90.9453H150.184V93.4722H152.729V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.729 88.4219H150.184V90.948H152.729V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.182 93.4727H147.637V95.9988H150.182V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.182 90.9453H147.637V93.4722H150.182V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.182 88.4219H147.637V90.948H150.182V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.635 93.4727H145.09V95.9988H147.635V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.635 90.9453H145.09V93.4722H147.635V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.635 88.4219H145.09V90.948H147.635V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.093 93.4727H142.547V95.9988H145.093V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.093 90.9453H142.547V93.4722H145.093V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.093 88.4219H142.547V90.948H145.093V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.545 93.4727H140V95.9988H142.545V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.545 90.9453H140V93.4722H142.545V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.545 88.4219H140V90.948H142.545V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.998 93.4727H137.453V95.9988H139.998V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.998 90.9453H137.453V93.4722H139.998V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.998 88.4219H137.453V90.948H139.998V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.455 93.4727H134.91V95.9988H137.455V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.455 90.9453H134.91V93.4722H137.455V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.455 88.4219H134.91V90.948H137.455V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.909 93.4727H132.363V95.9988H134.909V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.909 90.9453H132.363V93.4722H134.909V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.909 88.4219H132.363V90.948H134.909V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.362 93.4727H129.816V95.9988H132.362V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.362 90.9453H129.816V93.4722H132.362V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.362 88.4219H129.816V90.948H132.362V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.819 93.4727H127.273V95.9988H129.819V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.819 90.9453H127.273V93.4722H129.819V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.819 88.4219H127.273V90.948H129.819V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.272 93.4727H124.727V95.9988H127.272V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.272 90.9453H124.727V93.4722H127.272V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.272 88.4219H124.727V90.948H127.272V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.726 93.4727H122.18V95.9988H124.726V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.726 90.9453H122.18V93.4722H124.726V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.726 88.4219H122.18V90.948H124.726V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.182 93.4727H119.637V95.9988H122.182V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.182 90.9453H119.637V93.4722H122.182V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.182 88.4219H119.637V90.948H122.182V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.635 93.4727H117.09V95.9988H119.635V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.635 90.9453H117.09V93.4722H119.635V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.635 88.4219H117.09V90.948H119.635V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.092 93.4727H114.547V95.9988H117.092V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.092 90.9453H114.547V93.4722H117.092V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.092 88.4219H114.547V90.948H117.092V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.546 93.4727H112V95.9988H114.546V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.546 90.9453H112V93.4722H114.546V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.546 88.4219H112V90.948H114.546V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.998 93.4727H109.453V95.9988H111.998V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.998 90.9453H109.453V93.4722H111.998V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.998 88.4219H109.453V90.948H111.998V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.455 93.4727H106.91V95.9988H109.455V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.455 90.9453H106.91V93.4722H109.455V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.455 88.4219H106.91V90.948H109.455V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.909 93.4727H104.363V95.9988H106.909V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.909 90.9453H104.363V93.4722H106.909V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.909 88.4219H104.363V90.948H106.909V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.362 93.4727H101.816V95.9988H104.362V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.362 90.9453H101.816V93.4722H104.362V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.362 88.4219H101.816V90.948H104.362V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.819 93.4727H99.2734V95.9988H101.819V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.819 90.9453H99.2734V93.4722H101.819V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.819 88.4219H99.2734V90.948H101.819V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2718 93.4727H96.7266V95.9988H99.2718V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2718 90.9453H96.7266V93.4722H99.2718V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2718 88.4219H96.7266V90.948H99.2718V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 93.4727H94.1836V95.9988H96.7288V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 90.9453H94.1836V93.4722H96.7288V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 88.4219H94.1836V90.948H96.7288V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 93.4727H91.6367V95.9988H94.1827V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 90.9453H91.6367V93.4722H94.1827V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 88.4219H91.6367V90.948H94.1827V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6351 93.4727H89.0898V95.9988H91.6351V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6351 90.9453H89.0898V93.4722H91.6351V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6351 88.4219H89.0898V90.948H91.6351V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 93.4727H86.5469V95.9988H89.0921V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 90.9453H86.5469V93.4722H89.0921V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 88.4219H86.5469V90.948H89.0921V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 93.4727H84V95.9988H86.5453V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 90.9453H84V93.4722H86.5453V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 88.4219H84V90.948H86.5453V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9992 93.4727H81.4531V95.9988H83.9992V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9992 90.9453H81.4531V93.4722H83.9992V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9992 88.4219H81.4531V90.948H83.9992V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 93.4727H78.9102V95.9988H81.4554V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 90.9453H78.9102V93.4722H81.4554V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 88.4219H78.9102V90.948H81.4554V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 85.8945H78.9102V88.4206H81.4554V85.8945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 93.4727H76.3633V95.9988H78.9085V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 90.9453H76.3633V93.4722H78.9085V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 88.4219H76.3633V90.948H78.9085V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 85.8945H76.3633V88.4206H78.9085V85.8945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3624 93.4727H73.8164V95.9988H76.3624V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3624 90.9453H73.8164V93.4722H76.3624V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3624 88.4219H73.8164V90.948H76.3624V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3624 85.8945H73.8164V88.4206H76.3624V85.8945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 93.4727H71.2734V95.9988H73.8187V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 90.9453H71.2734V93.4722H73.8187V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 88.4219H71.2734V90.948H73.8187V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 85.8945H71.2734V88.4206H73.8187V85.8945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2718 93.4727H68.7266V95.9988H71.2718V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2718 90.9453H68.7266V93.4722H71.2718V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2718 88.4219H68.7266V90.948H71.2718V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2718 85.8945H68.7266V88.4206H71.2718V85.8945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 93.4727H66.1836V95.9988H68.7288V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 90.9453H66.1836V93.4722H68.7288V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 88.4219H66.1836V90.948H68.7288V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 85.8945H66.1836V88.4206H68.7288V85.8945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 93.4727H63.6367V95.9988H66.1827V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 90.9453H63.6367V93.4722H66.1827V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 88.4219H63.6367V90.948H66.1827V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 85.8945H63.6367V88.4206H66.1827V85.8945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6351 93.4727H61.0898V95.9988H63.6351V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6351 90.9453H61.0898V93.4722H63.6351V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6351 88.4219H61.0898V90.948H63.6351V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 93.4727H58.5469V95.9988H61.0921V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 90.9453H58.5469V93.4722H61.0921V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 88.4219H58.5469V90.948H61.0921V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 93.4727H56V95.9988H58.5453V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 90.9453H56V93.4722H58.5453V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 88.4219H56V90.948H58.5453V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9992 93.4727H53.4531V95.9988H55.9992V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9992 90.9453H53.4531V93.4722H55.9992V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9992 88.4219H53.4531V90.948H55.9992V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4554 93.4727H50.9102V95.9988H53.4554V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4554 90.9453H50.9102V93.4722H53.4554V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4554 88.4219H50.9102V90.948H53.4554V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9085 93.4727H48.3633V95.9988H50.9085V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9085 90.9453H48.3633V93.4722H50.9085V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9085 88.4219H48.3633V90.948H50.9085V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3656 93.4727H45.8203V95.9988H48.3656V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3656 90.9453H45.8203V93.4722H48.3656V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3656 88.4219H45.8203V90.948H48.3656V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8195 93.4727H43.2734V95.9988H45.8195V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8195 90.9453H43.2734V93.4722H45.8195V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8195 88.4219H43.2734V90.948H45.8195V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2718 93.4727H40.7266V95.9988H43.2718V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2718 90.9453H40.7266V93.4722H43.2718V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2718 88.4219H40.7266V90.948H43.2718V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7288 93.4727H38.1836V95.9988H40.7288V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7288 90.9453H38.1836V93.4722H40.7288V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7288 88.4219H38.1836V90.948H40.7288V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.182 93.4727H35.6367V95.9988H38.182V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.182 90.9453H35.6367V93.4722H38.182V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.182 88.4219H35.6367V90.948H38.182V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6359 93.4727H33.0898V95.9988H35.6359V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6359 90.9453H33.0898V93.4722H35.6359V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6359 88.4219H33.0898V90.948H35.6359V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0921 93.4727H30.5469V95.9988H33.0921V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0921 90.9453H30.5469V93.4722H33.0921V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0921 88.4219H30.5469V90.948H33.0921V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5453 93.4727H28V95.9988H30.5453V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5453 90.9453H28V93.4722H30.5453V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5453 88.4219H28V90.948H30.5453V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9984 93.4727H25.4531V95.9988H27.9984V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9984 90.9453H25.4531V93.4722H27.9984V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9984 88.4219H25.4531V90.948H27.9984V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4562 93.4727H22.9102V95.9988H25.4562V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4562 90.9453H22.9102V93.4722H25.4562V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4562 88.4219H22.9102V90.948H25.4562V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9085 93.4727H20.3633V95.9988H22.9085V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9085 90.9453H20.3633V93.4722H22.9085V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9085 88.4219H20.3633V90.948H22.9085V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3617 93.4727H17.8164V95.9988H20.3617V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3617 90.9453H17.8164V93.4722H20.3617V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3617 88.4219H17.8164V90.948H20.3617V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8187 93.4727H15.2734V95.9988H17.8187V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8187 90.9453H15.2734V93.4722H17.8187V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8187 88.4219H15.2734V90.948H17.8187V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2726 93.4727H12.7266V95.9988H15.2726V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2726 90.9453H12.7266V93.4722H15.2726V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2726 88.4219H12.7266V90.948H15.2726V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7289 93.4727H10.1836V95.9988H12.7289V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7289 90.9453H10.1836V93.4722H12.7289V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7289 88.4219H10.1836V90.948H12.7289V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.182 93.4727H7.63672V95.9988H10.182V93.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.182 90.9453H7.63672V93.4722H10.182V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.182 88.4219H7.63672V90.948H10.182V88.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6351 90.9453H5.08984V93.4722H7.6351V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0929 90.9453H2.54688V93.4722H5.0929V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.54526 90.9453H0V93.4722H2.54526V90.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 65.6875H96.7305V68.2136H99.2757V65.6875Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 68.2109H96.7305V70.7371H99.2757V68.2109Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 70.7383H96.7305V73.2652H99.2757V70.7383Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 73.2656H96.7305V75.7917H99.2757V73.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 75.793H96.7305V78.3191H99.2757V75.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 78.3164H96.7305V80.8425H99.2757V78.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 80.8438H96.7305V83.3706H99.2757V80.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 58.1055H86.5469V60.6316H89.0921V58.1055Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 60.6328H86.5469V63.1597H89.0921V60.6328Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 63.1602H86.5469V65.6863H89.0921V63.1602Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 65.6875H86.5469V68.2136H89.0921V65.6875Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 68.2109H86.5469V70.7371H89.0921V68.2109Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 70.7383H86.5469V73.2652H89.0921V70.7383Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 73.2656H86.5469V75.7917H89.0921V73.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 75.793H86.5469V78.3191H89.0921V75.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 78.3164H86.5469V80.8425H89.0921V78.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 80.8438H86.5469V83.3706H89.0921V80.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 83.3711H86.5469V85.8972H89.0921V83.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 85.8984H86.5469V88.4246H89.0921V85.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 58.1055H89.0938V60.6316H91.639V58.1055Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 60.6328H89.0938V63.1597H91.639V60.6328Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 63.1602H89.0938V65.6863H91.639V63.1602Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 65.6875H89.0938V68.2136H91.639V65.6875Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 68.2109H89.0938V70.7371H91.639V68.2109Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 70.7383H89.0938V73.2652H91.639V70.7383Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 73.2656H89.0938V75.7917H91.639V73.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 75.793H89.0938V78.3191H91.639V75.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 78.3164H89.0938V80.8425H91.639V78.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 80.8438H89.0938V83.3706H91.639V80.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 83.3711H89.0938V85.8972H91.639V83.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 60.6328H91.6367V63.1597H94.1827V60.6328Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 63.1602H91.6367V65.6863H94.1827V63.1602Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 65.6875H91.6367V68.2136H94.1827V65.6875Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 68.2109H91.6367V70.7371H94.1827V68.2109Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 70.7383H91.6367V73.2652H94.1827V70.7383Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 73.2656H91.6367V75.7917H94.1827V73.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 75.793H91.6367V78.3191H94.1827V75.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 78.3164H91.6367V80.8425H94.1827V78.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 80.8438H91.6367V83.3706H94.1827V80.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 83.3711H91.6367V85.8972H94.1827V83.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 60.6328H94.1836V63.1597H96.7288V60.6328Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 63.1602H94.1836V65.6863H96.7288V63.1602Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 65.6875H94.1836V68.2136H96.7288V65.6875Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 68.2109H94.1836V70.7371H96.7288V68.2109Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 70.7383H94.1836V73.2652H96.7288V70.7383Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 73.2656H94.1836V75.7917H96.7288V73.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 75.793H94.1836V78.3191H96.7288V75.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 78.3164H94.1836V80.8425H96.7288V78.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 80.8438H94.1836V83.3706H96.7288V80.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 83.3711H94.1836V85.8972H96.7288V83.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 85.8984H94.1836V88.4246H96.7288V85.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 85.8984H91.6367V88.4246H94.1827V85.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 85.8984H89.0938V88.4246H91.639V85.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 88.4219H89.0938V90.948H91.639V88.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 88.4219H86.5469V90.948H89.0921V88.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 60.6328H78.9102V63.1597H81.4554V60.6328Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 63.1602H78.9102V65.6863H81.4554V63.1602Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 65.6875H78.9102V68.2136H81.4554V65.6875Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 68.2109H78.9102V70.7371H81.4554V68.2109Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 70.7383H78.9102V73.2652H81.4554V70.7383Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 73.2656H78.9102V75.7917H81.4554V73.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 75.793H78.9102V78.3191H81.4554V75.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 78.3164H78.9102V80.8425H81.4554V78.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 80.8438H78.9102V83.3706H81.4554V80.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 83.3711H78.9102V85.8972H81.4554V83.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 85.8984H78.9102V88.4246H81.4554V85.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 58.1055H71.2734V60.6316H73.8187V58.1055Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 60.6328H71.2734V63.1597H73.8187V60.6328Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 63.1602H71.2734V65.6863H73.8187V63.1602Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 65.6875H71.2734V68.2136H73.8187V65.6875Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 68.2109H71.2734V70.7371H73.8187V68.2109Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 70.7383H71.2734V73.2652H73.8187V70.7383Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 73.2656H71.2734V75.7917H73.8187V73.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 75.793H71.2734V78.3191H73.8187V75.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 78.3164H71.2734V80.8425H73.8187V78.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 80.8438H71.2734V83.3706H73.8187V80.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 83.3711H71.2734V85.8972H73.8187V83.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 85.8984H71.2734V88.4246H73.8187V85.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 65.6875H61.0938V68.2136H63.639V65.6875Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 68.2109H61.0938V70.7371H63.639V68.2109Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 70.7383H61.0938V73.2652H63.639V70.7383Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 73.2656H61.0938V75.7917H63.639V73.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 75.793H61.0938V78.3191H63.639V75.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 78.3164H61.0938V80.8425H63.639V78.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 80.8438H61.0938V83.3706H63.639V80.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 60.6328H63.6367V63.1597H66.1827V60.6328Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 63.1602H63.6367V65.6863H66.1827V63.1602Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 65.6875H63.6367V68.2136H66.1827V65.6875Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 68.2109H63.6367V70.7371H66.1827V68.2109Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 70.7383H63.6367V73.2652H66.1827V70.7383Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 73.2656H63.6367V75.7917H66.1827V73.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 75.793H63.6367V78.3191H66.1827V75.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 78.3164H63.6367V80.8425H66.1827V78.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 80.8438H63.6367V83.3706H66.1827V80.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 83.3711H63.6367V85.8972H66.1827V83.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 85.8984H63.6367V88.4246H66.1827V85.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 60.6328H66.1836V63.1597H68.7288V60.6328Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 63.1602H66.1836V65.6863H68.7288V63.1602Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 65.6875H66.1836V68.2136H68.7288V65.6875Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 68.2109H66.1836V70.7371H68.7288V68.2109Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 70.7383H66.1836V73.2652H68.7288V70.7383Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 73.2656H66.1836V75.7917H68.7288V73.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 75.793H66.1836V78.3191H68.7288V75.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 78.3164H66.1836V80.8425H68.7288V78.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 80.8438H66.1836V83.3706H68.7288V80.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 83.3711H66.1836V85.8972H68.7288V83.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 85.8984H66.1836V88.4246H68.7288V85.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 58.1055H68.7305V60.6316H71.2757V58.1055Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 60.6328H68.7305V63.1597H71.2757V60.6328Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 63.1602H68.7305V65.6863H71.2757V63.1602Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 65.6875H68.7305V68.2136H71.2757V65.6875Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 68.2109H68.7305V70.7371H71.2757V68.2109Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 70.7383H68.7305V73.2652H71.2757V70.7383Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 73.2656H68.7305V75.7917H71.2757V73.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 75.793H68.7305V78.3191H71.2757V75.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 78.3164H68.7305V80.8425H71.2757V78.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 80.8438H68.7305V83.3706H71.2757V80.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 83.3711H68.7305V85.8972H71.2757V83.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 85.8984H68.7305V88.4246H71.2757V85.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 88.4219H68.7305V90.948H71.2757V88.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 88.4219H71.2734V90.948H73.8187V88.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 60.6328H73.8203V63.1597H76.3663V60.6328Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 63.1602H73.8203V65.6863H76.3663V63.1602Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 65.6875H73.8203V68.2136H76.3663V65.6875Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 68.2109H73.8203V70.7371H76.3663V68.2109Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 70.7383H73.8203V73.2652H76.3663V70.7383Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 73.2656H73.8203V75.7917H76.3663V73.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 75.793H73.8203V78.3191H76.3663V75.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 78.3164H73.8203V80.8425H76.3663V78.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 80.8438H73.8203V83.3706H76.3663V80.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 83.3711H73.8203V85.8972H76.3663V83.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 85.8984H73.8203V88.4246H76.3663V85.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 88.4219H73.8203V90.948H76.3663V88.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 60.6328H76.3633V63.1597H78.9085V60.6328Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 63.1602H76.3633V65.6863H78.9085V63.1602Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 65.6875H76.3633V68.2136H78.9085V65.6875Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 68.2109H76.3633V70.7371H78.9085V68.2109Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 70.7383H76.3633V73.2652H78.9085V70.7383Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 73.2656H76.3633V75.7917H78.9085V73.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 75.793H76.3633V78.3191H78.9085V75.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 78.3164H76.3633V80.8425H78.9085V78.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 80.8438H76.3633V83.3706H78.9085V80.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 83.3711H76.3633V85.8972H78.9085V83.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 85.8984H76.3633V88.4246H78.9085V85.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 88.4219H76.3633V90.948H78.9085V88.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 88.4219H78.9102V90.948H81.4554V88.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 60.6328H81.457V63.1597H84.0031V60.6328Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 63.1602H81.457V65.6863H84.0031V63.1602Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 65.6875H81.457V68.2136H84.0031V65.6875Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 68.2109H81.457V70.7371H84.0031V68.2109Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 70.7383H81.457V73.2652H84.0031V70.7383Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 73.2656H81.457V75.7917H84.0031V73.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 75.793H81.457V78.3191H84.0031V75.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 78.3164H81.457V80.8425H84.0031V78.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 80.8438H81.457V83.3706H84.0031V80.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 83.3711H81.457V85.8972H84.0031V83.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 85.8984H81.457V88.4246H84.0031V85.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 88.4219H81.457V90.948H84.0031V88.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 60.6328H84V63.1597H86.5453V60.6328Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 63.1602H84V65.6863H86.5453V63.1602Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 65.6875H84V68.2136H86.5453V65.6875Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 68.2109H84V70.7371H86.5453V68.2109Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 70.7383H84V73.2652H86.5453V70.7383Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 73.2656H84V75.7917H86.5453V73.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 75.793H84V78.3191H86.5453V75.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 78.3164H84V80.8425H86.5453V78.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 88.4219H84V90.948H86.5453V88.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 85.8984H84V88.4246H86.5453V85.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 83.3711H84V85.8972H86.5453V83.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 80.8438H84V83.3706H86.5453V80.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 88.4219H94.1836V90.948H96.7288V88.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 88.4219H91.6367V90.948H94.1827V88.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 83.3711H96.7305V85.8972H99.2757V83.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 85.8984H96.7305V88.4246H99.2757V85.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.819 80.8438H99.2734V83.3706H101.819V80.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.819 78.3164H99.2734V80.8425H101.819V78.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.819 75.793H99.2734V78.3191H101.819V75.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.819 73.2656H99.2734V75.7917H101.819V73.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.819 70.7383H99.2734V73.2652H101.819V70.7383Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.819 68.2109H99.2734V70.7371H101.819V68.2109Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.819 65.6875H99.2734V68.2136H101.819V65.6875Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 90.9492H89.0938V93.4761H91.639V90.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 90.9492H86.5469V93.4761H89.0921V90.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 90.9492H73.8203V93.4761H76.3663V90.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 90.9492H68.7305V93.4761H71.2757V90.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 90.9492H71.2734V93.4761H73.8187V90.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 90.9492H78.9102V93.4761H81.4554V90.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 90.9492H84V93.4761H86.5453V90.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 90.9492H81.457V93.4761H84.0031V90.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 90.9492H76.3633V93.4761H78.9085V90.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 88.4219H63.6367V90.948H66.1827V88.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 88.4219H66.1836V90.948H68.7288V88.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 85.8984H61.0938V88.4246H63.639V85.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 83.3711H61.0938V85.8972H63.639V83.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 78.3164H58.5469V80.8425H61.0921V78.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 68.2109H58.5469V70.7371H61.0921V68.2109Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 80.8438H58.5469V83.3706H61.0921V80.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 75.793H58.5469V78.3191H61.0921V75.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 73.2656H58.5469V75.7917H61.0921V73.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 70.7383H58.5469V73.2652H61.0921V70.7383Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 65.6875H58.5469V68.2136H61.0921V65.6875Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 63.1602H96.7305V65.6863H99.2757V63.1602Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 63.1602H61.0938V65.6863H63.639V63.1602Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 60.6328H96.7305V63.1597H99.2757V60.6328Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 45.4766H96.7305V48.0027H99.2757V45.4766Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 42.9492H96.7305V45.4761H99.2757V42.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 40.4219H96.7305V42.948H99.2757V40.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 37.8984H96.7305V40.4246H99.2757V37.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 35.3711H96.7305V37.8972H99.2757V35.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 58.1055H94.1836V60.6316H96.7288V58.1055Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 50.5273H94.1836V53.0535H96.7288V50.5273Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 48H94.1836V50.5261H96.7288V48Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 45.4766H94.1836V48.0027H96.7288V45.4766Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 42.9492H94.1836V45.4761H96.7288V42.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 40.4219H94.1836V42.948H96.7288V40.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 37.8984H94.1836V40.4246H96.7288V37.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 35.3711H94.1836V37.8972H96.7288V35.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 32.8438H94.1836V35.3706H96.7288V32.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 30.3164H94.1836V32.8425H96.7288V30.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 58.1055H91.6367V60.6316H94.1827V58.1055Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 53.0547H91.6367V55.5816H94.1827V53.0547Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 50.5273H91.6367V53.0535H94.1827V50.5273Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 48H91.6367V50.5261H94.1827V48Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 45.4766H91.6367V48.0027H94.1827V45.4766Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 42.9492H91.6367V45.4761H94.1827V42.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 40.4219H91.6367V42.948H94.1827V40.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 37.8984H91.6367V40.4246H94.1827V37.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 35.3711H91.6367V37.8972H94.1827V35.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 32.8438H91.6367V35.3706H94.1827V32.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 30.3164H91.6367V32.8425H94.1827V30.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 27.793H91.6367V30.3191H94.1827V27.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 55.582H89.0938V58.1081H91.639V55.582Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 53.0547H89.0938V55.5816H91.639V53.0547Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 50.5273H89.0938V53.0535H91.639V50.5273Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 48H89.0938V50.5261H91.639V48Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 45.4766H89.0938V48.0027H91.639V45.4766Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 42.9492H89.0938V45.4761H91.639V42.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 40.4219H89.0938V42.948H91.639V40.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 37.8984H89.0938V40.4246H91.639V37.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 35.3711H89.0938V37.8972H91.639V35.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 32.8438H89.0938V35.3706H91.639V32.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 30.3164H89.0938V32.8425H91.639V30.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 27.793H89.0938V30.3191H91.639V27.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 25.2656H89.0938V27.7917H91.639V25.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 55.582H86.5469V58.1081H89.0921V55.582Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 53.0547H86.5469V55.5816H89.0921V53.0547Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 50.5273H86.5469V53.0535H89.0921V50.5273Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 48H86.5469V50.5261H89.0921V48Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 45.4766H86.5469V48.0027H89.0921V45.4766Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 42.9492H86.5469V45.4761H89.0921V42.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 40.4219H86.5469V42.948H89.0921V40.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 37.8984H86.5469V40.4246H89.0921V37.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 35.3711H86.5469V37.8972H89.0921V35.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 32.8438H86.5469V35.3706H89.0921V32.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 30.3164H86.5469V32.8425H89.0921V30.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 27.793H86.5469V30.3191H89.0921V27.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 25.2656H86.5469V27.7917H89.0921V25.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 58.1055H84V60.6316H86.5453V58.1055Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 55.582H84V58.1081H86.5453V55.582Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 53.0547H84V55.5816H86.5453V53.0547Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 50.5273H84V53.0535H86.5453V50.5273Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 48H84V50.5261H86.5453V48Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 45.4766H84V48.0027H86.5453V45.4766Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 42.9492H84V45.4761H86.5453V42.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 40.4219H84V42.948H86.5453V40.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 37.8984H84V40.4246H86.5453V37.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 35.3711H84V37.8972H86.5453V35.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 32.8438H84V35.3706H86.5453V32.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 30.3164H84V32.8425H86.5453V30.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 27.793H84V30.3191H86.5453V27.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 25.2656H84V27.7917H86.5453V25.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 22.7383H84V25.2652H86.5453V22.7383Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 58.1055H81.457V60.6316H84.0031V58.1055Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 55.582H81.457V58.1081H84.0031V55.582Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 53.0547H81.457V55.5816H84.0031V53.0547Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 50.5273H81.457V53.0535H84.0031V50.5273Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 48H81.457V50.5261H84.0031V48Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 45.4766H81.457V48.0027H84.0031V45.4766Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 42.9492H81.457V45.4761H84.0031V42.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 40.4219H81.457V42.948H84.0031V40.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 37.8984H81.457V40.4246H84.0031V37.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 35.3711H81.457V37.8972H84.0031V35.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 32.8438H81.457V35.3706H84.0031V32.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 30.3164H81.457V32.8425H84.0031V30.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 27.793H81.457V30.3191H84.0031V27.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 25.2656H81.457V27.7917H84.0031V25.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 22.7383H81.457V25.2652H84.0031V22.7383Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 58.1055H78.9102V60.6316H81.4554V58.1055Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 55.582H78.9102V58.1081H81.4554V55.582Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 53.0547H78.9102V55.5816H81.4554V53.0547Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 50.5273H78.9102V53.0535H81.4554V50.5273Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 48H78.9102V50.5261H81.4554V48Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 45.4766H78.9102V48.0027H81.4554V45.4766Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 42.9492H78.9102V45.4761H81.4554V42.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 40.4219H78.9102V42.948H81.4554V40.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 37.8984H78.9102V40.4246H81.4554V37.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 35.3711H78.9102V37.8972H81.4554V35.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 32.8438H78.9102V35.3706H81.4554V32.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 30.3164H78.9102V32.8425H81.4554V30.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 27.793H78.9102V30.3191H81.4554V27.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 25.2656H78.9102V27.7917H81.4554V25.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 22.7383H78.9102V25.2652H81.4554V22.7383Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 58.1055H76.3633V60.6316H78.9085V58.1055Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 55.582H76.3633V58.1081H78.9085V55.582Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 53.0547H76.3633V55.5816H78.9085V53.0547Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 50.5273H76.3633V53.0535H78.9085V50.5273Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 48H76.3633V50.5261H78.9085V48Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 45.4766H76.3633V48.0027H78.9085V45.4766Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 42.9492H76.3633V45.4761H78.9085V42.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 40.4219H76.3633V42.948H78.9085V40.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 37.8984H76.3633V40.4246H78.9085V37.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 35.3711H76.3633V37.8972H78.9085V35.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 32.8438H76.3633V35.3706H78.9085V32.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 30.3164H76.3633V32.8425H78.9085V30.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 27.793H76.3633V30.3191H78.9085V27.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 25.2656H76.3633V27.7917H78.9085V25.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 22.7383H76.3633V25.2652H78.9085V22.7383Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 58.1055H73.8203V60.6316H76.3663V58.1055Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 55.582H73.8203V58.1081H76.3663V55.582Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 53.0547H73.8203V55.5816H76.3663V53.0547Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 50.5273H73.8203V53.0535H76.3663V50.5273Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 48H73.8203V50.5261H76.3663V48Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 45.4766H73.8203V48.0027H76.3663V45.4766Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 42.9492H73.8203V45.4761H76.3663V42.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 40.4219H73.8203V42.948H76.3663V40.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 37.8984H73.8203V40.4246H76.3663V37.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 35.3711H73.8203V37.8972H76.3663V35.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 32.8438H73.8203V35.3706H76.3663V32.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 30.3164H73.8203V32.8425H76.3663V30.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 27.793H73.8203V30.3191H76.3663V27.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 25.2656H73.8203V27.7917H76.3663V25.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 22.7383H73.8203V25.2652H76.3663V22.7383Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 55.582H71.2734V58.1081H73.8187V55.582Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 53.0547H71.2734V55.5816H73.8187V53.0547Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 50.5273H71.2734V53.0535H73.8187V50.5273Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 48H71.2734V50.5261H73.8187V48Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 45.4766H71.2734V48.0027H73.8187V45.4766Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 42.9492H71.2734V45.4761H73.8187V42.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 40.4219H71.2734V42.948H73.8187V40.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 37.8984H71.2734V40.4246H73.8187V37.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 35.3711H71.2734V37.8972H73.8187V35.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 32.8438H71.2734V35.3706H73.8187V32.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 30.3164H71.2734V32.8425H73.8187V30.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 27.793H71.2734V30.3191H73.8187V27.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 25.2656H71.2734V27.7917H73.8187V25.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 55.582H68.7305V58.1081H71.2757V55.582Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 53.0547H68.7305V55.5816H71.2757V53.0547Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 50.5273H68.7305V53.0535H71.2757V50.5273Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 48H68.7305V50.5261H71.2757V48Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 45.4766H68.7305V48.0027H71.2757V45.4766Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 42.9492H68.7305V45.4761H71.2757V42.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 40.4219H68.7305V42.948H71.2757V40.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 37.8984H68.7305V40.4246H71.2757V37.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 35.3711H68.7305V37.8972H71.2757V35.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 32.8438H68.7305V35.3706H71.2757V32.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 30.3164H68.7305V32.8425H71.2757V30.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 27.793H68.7305V30.3191H71.2757V27.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 25.2656H68.7305V27.7917H71.2757V25.2656Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 58.1055H66.1836V60.6316H68.7288V58.1055Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 53.0547H66.1836V55.5816H68.7288V53.0547Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 50.5273H66.1836V53.0535H68.7288V50.5273Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 48H66.1836V50.5261H68.7288V48Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 45.4766H66.1836V48.0027H68.7288V45.4766Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 42.9492H66.1836V45.4761H68.7288V42.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 40.4219H66.1836V42.948H68.7288V40.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 37.8984H66.1836V40.4246H68.7288V37.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 35.3711H66.1836V37.8972H68.7288V35.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 32.8438H66.1836V35.3706H68.7288V32.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 30.3164H66.1836V32.8425H68.7288V30.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 27.793H66.1836V30.3191H68.7288V27.793Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 58.1055H63.6367V60.6316H66.1827V58.1055Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 50.5273H63.6367V53.0535H66.1827V50.5273Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 48H63.6367V50.5261H66.1827V48Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 45.4766H63.6367V48.0027H66.1827V45.4766Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 42.9492H63.6367V45.4761H66.1827V42.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 40.4219H63.6367V42.948H66.1827V40.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 37.8984H63.6367V40.4246H66.1827V37.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 35.3711H63.6367V37.8972H66.1827V35.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 32.8438H63.6367V35.3706H66.1827V32.8438Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 30.3164H63.6367V32.8425H66.1827V30.3164Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 60.6328H61.0938V63.1597H63.639V60.6328Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 45.4766H61.0938V48.0027H63.639V45.4766Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 42.9492H61.0938V45.4761H63.639V42.9492Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 40.4219H61.0938V42.948H63.639V40.4219Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 37.8984H61.0938V40.4246H63.639V37.8984Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 35.3711H61.0938V37.8972H63.639V35.3711Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.639 45.4727H117.094V47.9988H119.639V45.4727Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.639 42.9453H117.094V45.4722H119.639V42.9453Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.092 48H114.547V50.5261H117.092V48Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.546 55.5781H112V58.1042H114.546V55.5781Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.546 53.0508H112V55.5777H114.546V53.0508Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.546 50.5234H112V53.0496H114.546V50.5234Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.546 48H112V50.5261H114.546V48Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.546 45.4727H112V47.9988H114.546V45.4727Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.546 42.9453H112V45.4722H114.546V42.9453Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.546 40.418H112V42.9441H114.546V40.418Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.546 37.8945H112V40.4206H114.546V37.8945Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.002 60.6289H109.457V63.1558H112.002V60.6289Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.002 58.1016H109.457V60.6277H112.002V58.1016Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.002 48H109.457V50.5261H112.002V48Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.455 63.1562H106.91V65.6824H109.455V63.1562Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.455 45.4727H106.91V47.9988H109.455V45.4727Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.455 42.9453H106.91V45.4722H109.455V42.9453Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.455 40.418H106.91V42.9441H109.455V40.418Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.909 65.6836H104.363V68.2097H106.909V65.6836Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.366 65.6836H101.82V68.2097H104.366V65.6836Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.819 68.207H99.2734V70.7331H101.819V68.207Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 27.7891H91.6367V30.3152H94.1827V27.7891Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 25.2617H89.0938V27.7878H91.639V25.2617Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 25.2617H86.5469V27.7878H89.0921V25.2617Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 27.7891H84V30.3152H86.5453V27.7891Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 27.7891H81.457V30.3152H84.0031V27.7891Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 27.7891H78.9102V30.3152H81.4554V27.7891Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 27.7891H76.3633V30.3152H78.9085V27.7891Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 30.3125H73.8203V32.8386H76.3663V30.3125Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 30.3125H71.2734V32.8386H73.8187V30.3125Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2718 30.3125H68.7266V32.8386H71.2718V30.3125Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 32.8398H66.1836V35.3667H68.7288V32.8398Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 45.4727H63.6367V47.9988H66.1827V45.4727Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 42.9453H63.6367V45.4722H66.1827V42.9453Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 32.8398H63.6367V35.3667H66.1827V32.8398Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6351 68.207H61.0898V70.7331H63.6351V68.207Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6351 45.4727H61.0898V47.9988H63.6351V45.4727Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6351 42.9453H61.0898V45.4722H63.6351V42.9453Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6351 40.418H61.0898V42.9441H63.6351V40.418Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6351 37.8945H61.0898V40.4206H63.6351V37.8945Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6351 35.3672H61.0898V37.8933H63.6351V35.3672Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 65.6836H58.5469V68.2097H61.0921V65.6836Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 65.6836H56V68.2097H58.5453V65.6836Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0031 63.1562H53.457V65.6824H56.0031V63.1562Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0031 48H53.457V50.5261H56.0031V48Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4554 60.6289H50.9102V63.1558H53.4554V60.6289Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4554 58.1016H50.9102V60.6277H53.4554V58.1016Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4554 50.5234H50.9102V53.0496H53.4554V50.5234Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9085 55.5781H48.3633V58.1042H50.9085V55.5781Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9085 53.0508H48.3633V55.5777H50.9085V53.0508Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9085 50.5234H48.3633V53.0496H50.9085V50.5234Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9085 48H48.3633V50.5261H50.9085V48Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9085 45.4727H48.3633V47.9988H50.9085V45.4727Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9085 42.9453H48.3633V45.4722H50.9085V42.9453Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9085 40.418H48.3633V42.9441H50.9085V40.418Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3656 50.5234H45.8203V53.0496H48.3656V50.5234Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8195 48H43.2734V50.5261H45.8195V48Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8195 45.4727H43.2734V47.9988H45.8195V45.4727Z",
    fill: "#A57B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.819 58.1055H99.2734V60.6316H101.819V58.1055Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.819 55.5781H99.2734V58.1042H101.819V55.5781Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.819 53.0508H99.2734V55.5777H101.819V53.0508Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.819 50.5273H99.2734V53.0535H101.819V50.5273Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 63.1602H96.7305V65.6863H99.2757V63.1602Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 60.6328H96.7305V63.1597H99.2757V60.6328Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 58.1055H96.7305V60.6316H99.2757V58.1055Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 55.5781H96.7305V58.1042H99.2757V55.5781Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 53.0508H96.7305V55.5777H99.2757V53.0508Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 50.5273H96.7305V53.0535H99.2757V50.5273Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 48H96.7305V50.5261H99.2757V48Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 83.3672H94.1836V85.8933H96.7288V83.3672Z",
    fill: "#32A542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 80.8398H94.1836V83.3667H96.7288V80.8398Z",
    fill: "#32A542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 78.3164H94.1836V80.8425H96.7288V78.3164Z",
    fill: "#32A542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 75.7891H94.1836V78.3152H96.7288V75.7891Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 73.2617H94.1836V75.7878H96.7288V73.2617Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 70.7383H94.1836V73.2652H96.7288V70.7383Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 68.2109H94.1836V70.7371H96.7288V68.2109Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 65.6836H94.1836V68.2097H96.7288V65.6836Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 63.1602H94.1836V65.6863H96.7288V63.1602Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 60.6328H94.1836V63.1597H96.7288V60.6328Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 58.1055H94.1836V60.6316H96.7288V58.1055Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 55.5781H94.1836V58.1042H96.7288V55.5781Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 53.0508H94.1836V55.5777H96.7288V53.0508Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 85.8945H91.6367V88.4206H94.1827V85.8945Z",
    fill: "#32A542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 83.3672H91.6367V85.8933H94.1827V83.3672Z",
    fill: "#32A542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 80.8398H91.6367V83.3667H94.1827V80.8398Z",
    fill: "#32A542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 78.3164H91.6367V80.8425H94.1827V78.3164Z",
    fill: "#32A542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 75.7891H91.6367V78.3152H94.1827V75.7891Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 73.2617H91.6367V75.7878H94.1827V73.2617Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 70.7383H91.6367V73.2652H94.1827V70.7383Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 68.2109H91.6367V70.7371H94.1827V68.2109Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 65.6836H91.6367V68.2097H94.1827V65.6836Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 63.1602H91.6367V65.6863H94.1827V63.1602Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 60.6328H91.6367V63.1597H94.1827V60.6328Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 58.1055H91.6367V60.6316H94.1827V58.1055Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 55.5781H91.6367V58.1042H94.1827V55.5781Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 42.9453H91.6367V45.4722H94.1827V42.9453Z",
    fill: "#F99348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 80.8398H89.0938V83.3667H91.639V80.8398Z",
    fill: "#32A542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 78.3164H89.0938V80.8425H91.639V78.3164Z",
    fill: "#32A542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 75.7891H89.0938V78.3152H91.639V75.7891Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 73.2617H89.0938V75.7878H91.639V73.2617Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 70.7383H89.0938V73.2652H91.639V70.7383Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 68.2109H89.0938V70.7371H91.639V68.2109Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 65.6836H89.0938V68.2097H91.639V65.6836Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 63.1602H89.0938V65.6863H91.639V63.1602Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 60.6328H89.0938V63.1597H91.639V60.6328Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 58.1055H89.0938V60.6316H91.639V58.1055Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 55.5781H89.0938V58.1042H91.639V55.5781Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 45.4727H89.0938V47.9988H91.639V45.4727Z",
    fill: "#D36818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 42.9453H89.0938V45.4722H91.639V42.9453Z",
    fill: "#E57E29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 40.4219H89.0938V42.948H91.639V40.4219Z",
    fill: "#353433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 37.8945H89.0938V40.4206H91.639V37.8945Z",
    fill: "#353433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 35.3672H89.0938V37.8933H91.639V35.3672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.639 22.7383H89.0938V25.2652H91.639V22.7383Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 83.3672H86.5469V85.8933H89.0921V83.3672Z",
    fill: "#32A542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 80.8398H86.5469V83.3667H89.0921V80.8398Z",
    fill: "#32A542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 78.3164H86.5469V80.8425H89.0921V78.3164Z",
    fill: "#32A542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 75.7891H86.5469V78.3152H89.0921V75.7891Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 73.2617H86.5469V75.7878H89.0921V73.2617Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 70.7383H86.5469V73.2652H89.0921V70.7383Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 68.2109H86.5469V70.7371H89.0921V68.2109Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 65.6836H86.5469V68.2097H89.0921V65.6836Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 63.1602H86.5469V65.6863H89.0921V63.1602Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 60.6328H86.5469V63.1597H89.0921V60.6328Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 58.1055H86.5469V60.6316H89.0921V58.1055Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 55.5781H86.5469V58.1042H89.0921V55.5781Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 45.4727H86.5469V47.9988H89.0921V45.4727Z",
    fill: "#D36818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 42.9453H86.5469V45.4722H89.0921V42.9453Z",
    fill: "#F99348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 22.7383H86.5469V25.2652H89.0921V22.7383Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 65.6836H84V68.2097H86.5453V65.6836Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 63.1602H84V65.6863H86.5453V63.1602Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 60.6328H84V63.1597H86.5453V60.6328Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 58.1055H84V60.6316H86.5453V58.1055Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 55.5781H84V58.1042H86.5453V55.5781Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 45.4727H84V47.9988H86.5453V45.4727Z",
    fill: "#D36818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 42.9453H84V45.4722H86.5453V42.9453Z",
    fill: "#E57E29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 25.2617H84V27.7878H86.5453V25.2617Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 22.7383H84V25.2652H86.5453V22.7383Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 20.2109H84V22.7371H86.5453V20.2109Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 65.6836H81.457V68.2097H84.0031V65.6836Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 63.1602H81.457V65.6863H84.0031V63.1602Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 60.6328H81.457V63.1597H84.0031V60.6328Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 58.1055H81.457V60.6316H84.0031V58.1055Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 55.5781H81.457V58.1042H84.0031V55.5781Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 45.4727H81.457V47.9988H84.0031V45.4727Z",
    fill: "#D36818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 42.9453H81.457V45.4722H84.0031V42.9453Z",
    fill: "#F99348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 25.2617H81.457V27.7878H84.0031V25.2617Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 22.7383H81.457V25.2652H84.0031V22.7383Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 20.2109H81.457V22.7371H84.0031V20.2109Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 17.6836H81.457V20.2097H84.0031V17.6836Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 15.1602H81.457V17.6863H84.0031V15.1602Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 65.6836H78.9102V68.2097H81.4554V65.6836Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 63.1602H78.9102V65.6863H81.4554V63.1602Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 60.6328H78.9102V63.1597H81.4554V60.6328Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 58.1055H78.9102V60.6316H81.4554V58.1055Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 55.5781H78.9102V58.1042H81.4554V55.5781Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 45.4727H78.9102V47.9988H81.4554V45.4727Z",
    fill: "#D36818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 42.9453H78.9102V45.4722H81.4554V42.9453Z",
    fill: "#E57E29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 25.2617H78.9102V27.7878H81.4554V25.2617Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 22.7383H78.9102V25.2652H81.4554V22.7383Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 20.2109H78.9102V22.7371H81.4554V20.2109Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 17.6836H78.9102V20.2097H81.4554V17.6836Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 15.1602H78.9102V17.6863H81.4554V15.1602Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 12.6328H78.9102V15.1597H81.4554V12.6328Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 10.1055H78.9102V12.6316H81.4554V10.1055Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 65.6836H76.3633V68.2097H78.9085V65.6836Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 63.1602H76.3633V65.6863H78.9085V63.1602Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 60.6328H76.3633V63.1597H78.9085V60.6328Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 58.1055H76.3633V60.6316H78.9085V58.1055Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 55.5781H76.3633V58.1042H78.9085V55.5781Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 25.2617H76.3633V27.7878H78.9085V25.2617Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 22.7383H76.3633V25.2652H78.9085V22.7383Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 20.2109H76.3633V22.7371H78.9085V20.2109Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 17.6836H76.3633V20.2097H78.9085V17.6836Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 15.1602H76.3633V17.6863H78.9085V15.1602Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 12.6328H76.3633V15.1597H78.9085V12.6328Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 10.1055H76.3633V12.6316H78.9085V10.1055Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 7.57812H76.3633V10.1042H78.9085V7.57812Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 5.05469H76.3633V7.5808H78.9085V5.05469Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 65.6836H73.8203V68.2097H76.3663V65.6836Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 63.1602H73.8203V65.6863H76.3663V63.1602Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 60.6328H73.8203V63.1597H76.3663V60.6328Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 58.1055H73.8203V60.6316H76.3663V58.1055Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 55.5781H73.8203V58.1042H76.3663V55.5781Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 27.7891H73.8203V30.3152H76.3663V27.7891Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 25.2617H73.8203V27.7878H76.3663V25.2617Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 22.7383H73.8203V25.2652H76.3663V22.7383Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 20.2109H73.8203V22.7371H76.3663V20.2109Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 17.6836H73.8203V20.2097H76.3663V17.6836Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 15.1602H73.8203V17.6863H76.3663V15.1602Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 12.6328H73.8203V15.1597H76.3663V12.6328Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 10.1055H73.8203V12.6316H76.3663V10.1055Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 7.57812H73.8203V10.1042H76.3663V7.57812Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 5.05469H73.8203V7.5808H76.3663V5.05469Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 2.52734H73.8203V5.05422H76.3663V2.52734Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 65.6836H71.2734V68.2097H73.8187V65.6836Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 63.1602H71.2734V65.6863H73.8187V63.1602Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 60.6328H71.2734V63.1597H73.8187V60.6328Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 58.1055H71.2734V60.6316H73.8187V58.1055Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 55.5781H71.2734V58.1042H73.8187V55.5781Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 40.4219H71.2734V42.948H73.8187V40.4219Z",
    fill: "#353433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 37.8945H71.2734V40.4206H73.8187V37.8945Z",
    fill: "#353433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 35.3672H71.2734V37.8933H73.8187V35.3672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 27.7891H71.2734V30.3152H73.8187V27.7891Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 25.2617H71.2734V27.7878H73.8187V25.2617Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 22.7383H71.2734V25.2652H73.8187V22.7383Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 20.2109H71.2734V22.7371H73.8187V20.2109Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 17.6836H71.2734V20.2097H73.8187V17.6836Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 15.1602H71.2734V17.6863H73.8187V15.1602Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 12.6328H71.2734V15.1597H73.8187V12.6328Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 10.1055H71.2734V12.6316H73.8187V10.1055Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 7.57812H71.2734V10.1042H73.8187V7.57812Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 5.05469H71.2734V7.5808H73.8187V5.05469Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 2.52734H71.2734V5.05422H73.8187V2.52734Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 0H71.2734V2.52612H73.8187V0Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2718 65.6836H68.7266V68.2097H71.2718V65.6836Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2718 63.1602H68.7266V65.6863H71.2718V63.1602Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2718 60.6328H68.7266V63.1597H71.2718V60.6328Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2718 58.1055H68.7266V60.6316H71.2718V58.1055Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2718 55.5781H68.7266V58.1042H71.2718V55.5781Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2718 27.7891H68.7266V30.3152H71.2718V27.7891Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2718 25.2617H68.7266V27.7878H71.2718V25.2617Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2718 22.7383H68.7266V25.2652H71.2718V22.7383Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2718 20.2109H68.7266V22.7371H71.2718V20.2109Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2718 17.6836H68.7266V20.2097H71.2718V17.6836Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2718 15.1602H68.7266V17.6863H71.2718V15.1602Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2718 12.6328H68.7266V15.1597H71.2718V12.6328Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2718 10.1055H68.7266V12.6316H71.2718V10.1055Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2718 7.57812H68.7266V10.1042H71.2718V7.57812Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2718 5.05469H68.7266V7.5808H71.2718V5.05469Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2718 2.52734H68.7266V5.05422H71.2718V2.52734Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2718 0H68.7266V2.52612H71.2718V0Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 63.1602H66.1836V65.6863H68.7288V63.1602Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 60.6328H66.1836V63.1597H68.7288V60.6328Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 58.1055H66.1836V60.6316H68.7288V58.1055Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 55.5781H66.1836V58.1042H68.7288V55.5781Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 30.3164H66.1836V32.8425H68.7288V30.3164Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 27.7891H66.1836V30.3152H68.7288V27.7891Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 25.2617H66.1836V27.7878H68.7288V25.2617Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 22.7383H66.1836V25.2652H68.7288V22.7383Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 20.2109H66.1836V22.7371H68.7288V20.2109Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 17.6836H66.1836V20.2097H68.7288V17.6836Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 15.1602H66.1836V17.6863H68.7288V15.1602Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 12.6328H66.1836V15.1597H68.7288V12.6328Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 10.1055H66.1836V12.6316H68.7288V10.1055Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 7.57812H66.1836V10.1042H68.7288V7.57812Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 5.05469H66.1836V7.5808H68.7288V5.05469Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 2.52734H66.1836V5.05422H68.7288V2.52734Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 63.1602H63.6367V65.6863H66.1827V63.1602Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 60.6328H63.6367V63.1597H66.1827V60.6328Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 58.1055H63.6367V60.6316H66.1827V58.1055Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 55.5781H63.6367V58.1042H66.1827V55.5781Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 53.0508H63.6367V55.5777H66.1827V53.0508Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 30.3164H63.6367V32.8425H66.1827V30.3164Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 27.7891H63.6367V30.3152H66.1827V27.7891Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 25.2617H63.6367V27.7878H66.1827V25.2617Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 22.7383H63.6367V25.2652H66.1827V22.7383Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 20.2109H63.6367V22.7371H66.1827V20.2109Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 17.6836H63.6367V20.2097H66.1827V17.6836Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 15.1602H63.6367V17.6863H66.1827V15.1602Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 12.6328H63.6367V15.1597H66.1827V12.6328Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 10.1055H63.6367V12.6316H66.1827V10.1055Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 7.57812H63.6367V10.1042H66.1827V7.57812Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 5.05469H63.6367V7.5808H66.1827V5.05469Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 2.52734H63.6367V5.05422H66.1827V2.52734Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 63.1602H61.0938V65.6863H63.639V63.1602Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 60.6328H61.0938V63.1597H63.639V60.6328Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 58.1055H61.0938V60.6316H63.639V58.1055Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 55.5781H61.0938V58.1042H63.639V55.5781Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 53.0508H61.0938V55.5777H63.639V53.0508Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 50.5273H61.0938V53.0535H63.639V50.5273Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 48H61.0938V50.5261H63.639V48Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 32.8398H61.0938V35.3667H63.639V32.8398Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 30.3164H61.0938V32.8425H63.639V30.3164Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 27.7891H61.0938V30.3152H63.639V27.7891Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 25.2617H61.0938V27.7878H63.639V25.2617Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 22.7383H61.0938V25.2652H63.639V22.7383Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 20.2109H61.0938V22.7371H63.639V20.2109Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 17.6836H61.0938V20.2097H63.639V17.6836Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 15.1602H61.0938V17.6863H63.639V15.1602Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 12.6328H61.0938V15.1597H63.639V12.6328Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 10.1055H61.0938V12.6316H63.639V10.1055Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 7.57812H61.0938V10.1042H63.639V7.57812Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 5.05469H61.0938V7.5808H63.639V5.05469Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 60.6328H58.5469V63.1597H61.0921V60.6328Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 58.1055H58.5469V60.6316H61.0921V58.1055Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 55.5781H58.5469V58.1042H61.0921V55.5781Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 53.0508H58.5469V55.5777H61.0921V53.0508Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 50.5273H58.5469V53.0535H61.0921V50.5273Z",
    fill: "#BC0A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 45.4727H58.5469V47.9988H61.0921V45.4727Z",
    fill: "#FFE6EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 42.9453H58.5469V45.4722H61.0921V42.9453Z",
    fill: "#FFE6EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 32.8398H58.5469V35.3667H61.0921V32.8398Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 30.3164H58.5469V32.8425H61.0921V30.3164Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 27.7891H58.5469V30.3152H61.0921V27.7891Z",
    fill: "#FFE6EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 25.2617H58.5469V27.7878H61.0921V25.2617Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 22.7383H58.5469V25.2652H61.0921V22.7383Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 20.2109H58.5469V22.7371H61.0921V20.2109Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 17.6836H58.5469V20.2097H61.0921V17.6836Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 15.1602H58.5469V17.6863H61.0921V15.1602Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 12.6328H58.5469V15.1597H61.0921V12.6328Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 10.1055H58.5469V12.6316H61.0921V10.1055Z",
    fill: "#F4A9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 7.57812H58.5469V10.1042H61.0921V7.57812Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 42.9453H56V45.4722H58.5453V42.9453Z",
    fill: "#FFE6EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 40.4219H56V42.948H58.5453V40.4219Z",
    fill: "#FFE6EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 37.8945H56V40.4206H58.5453V37.8945Z",
    fill: "#FFE6EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 32.8398H56V35.3667H58.5453V32.8398Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 30.3164H56V32.8425H58.5453V30.3164Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 27.7891H56V30.3152H58.5453V27.7891Z",
    fill: "#FFE6EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 25.2617H56V27.7878H58.5453V25.2617Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 22.7383H56V25.2652H58.5453V22.7383Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 20.2109H56V22.7371H58.5453V20.2109Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 17.6836H56V20.2097H58.5453V17.6836Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 15.1602H56V17.6863H58.5453V15.1602Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 12.6328H56V15.1597H58.5453V12.6328Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 10.1055H56V12.6316H58.5453V10.1055Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 7.57812H56V10.1042H58.5453V7.57812Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0031 42.9453H53.457V45.4722H56.0031V42.9453Z",
    fill: "#FFE6EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0031 40.4219H53.457V42.948H56.0031V40.4219Z",
    fill: "#FFE6EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0031 37.8945H53.457V40.4206H56.0031V37.8945Z",
    fill: "#FFE6EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0031 35.3672H53.457V37.8933H56.0031V35.3672Z",
    fill: "#FFE6EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0031 32.8398H53.457V35.3667H56.0031V32.8398Z",
    fill: "#FFE6EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0031 30.3164H53.457V32.8425H56.0031V30.3164Z",
    fill: "#FFE6EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0031 22.7383H53.457V25.2652H56.0031V22.7383Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0031 20.2109H53.457V22.7371H56.0031V20.2109Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0031 17.6836H53.457V20.2097H56.0031V17.6836Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0031 15.1602H53.457V17.6863H56.0031V15.1602Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0031 12.6328H53.457V15.1597H56.0031V12.6328Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0031 10.1055H53.457V12.6316H56.0031V10.1055Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4554 15.1602H50.9102V17.6863H53.4554V15.1602Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4554 12.6328H50.9102V15.1597H53.4554V12.6328Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4554 10.1055H50.9102V12.6316H53.4554V10.1055Z",
    fill: "#E58683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.819 65.6836H99.2734V68.2097H101.819V65.6836Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 68.2109H96.7305V70.7371H99.2757V68.2109Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2757 65.6836H96.7305V68.2097H99.2757V65.6836Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 70.7344H84V73.2613H86.5453V70.7344Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 68.2109H84V70.7371H86.5453V68.2109Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 70.7344H81.457V73.2613H84.0031V70.7344Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0031 68.2109H81.457V70.7371H84.0031V68.2109Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 70.7344H78.9102V73.2613H81.4554V70.7344Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 68.2109H78.9102V70.7371H81.4554V68.2109Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 70.7344H76.3633V73.2613H78.9085V70.7344Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 68.2109H76.3633V70.7371H78.9085V68.2109Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 70.7344H73.8203V73.2613H76.3663V70.7344Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3663 68.2109H73.8203V70.7371H76.3663V68.2109Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 90.9453H71.2734V93.4722H73.8187V90.9453Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 70.7344H71.2734V73.2613H73.8187V70.7344Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8187 68.2109H71.2734V70.7371H73.8187V68.2109Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 90.9453H68.7305V93.4722H71.2757V90.9453Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 70.7344H68.7305V73.2613H71.2757V70.7344Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2757 68.2109H68.7305V70.7371H71.2757V68.2109Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 88.4219H66.1836V90.948H68.7288V88.4219Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 68.2109H66.1836V70.7371H68.7288V68.2109Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 65.6836H66.1836V68.2097H68.7288V65.6836Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 88.4219H63.6367V90.948H66.1827V88.4219Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 85.8945H63.6367V88.4206H66.1827V85.8945Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 68.2109H63.6367V70.7371H66.1827V68.2109Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 65.6836H63.6367V68.2097H66.1827V65.6836Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 85.8945H61.0938V88.4206H63.639V85.8945Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 83.3672H61.0938V85.8933H63.639V83.3672Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 80.8398H61.0938V83.3667H63.639V80.8398Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 78.3164H61.0938V80.8425H63.639V78.3164Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 75.7891H61.0938V78.3152H63.639V75.7891Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 73.2617H61.0938V75.7878H63.639V73.2617Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 70.7344H61.0938V73.2613H63.639V70.7344Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.639 65.6836H61.0938V68.2097H63.639V65.6836Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 80.8398H58.5469V83.3667H61.0921V80.8398Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 78.3164H58.5469V80.8425H61.0921V78.3164Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 75.7891H58.5469V78.3152H61.0921V75.7891Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 73.2617H58.5469V75.7878H61.0921V73.2617Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 70.7344H58.5469V73.2613H61.0921V70.7344Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 68.2109H58.5469V70.7371H61.0921V68.2109Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.909 90.9453H132.363V93.4722H134.909V90.9453Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.366 90.9453H129.82V93.4722H132.366V90.9453Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.366 88.418H129.82V90.9441H132.366V88.418Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.819 90.9453H127.273V93.4722H129.819V90.9453Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.819 88.418H127.273V90.9441H129.819V88.418Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.819 78.3125H127.273V80.8386H129.819V78.3125Z",
    fill: "#32A542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.272 90.9453H124.727V93.4722H127.272V90.9453Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.272 88.418H124.727V90.9441H127.272V88.418Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.272 85.8945H124.727V88.4206H127.272V85.8945Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.272 80.8398H124.727V83.3667H127.272V80.8398Z",
    fill: "#32A542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.73 90.9453H122.184V93.4722H124.73V90.9453Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.73 88.418H122.184V90.9441H124.73V88.418Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.73 85.8945H122.184V88.4206H124.73V85.8945Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.73 83.3672H122.184V85.8933H124.73V83.3672Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.182 90.9453H119.637V93.4722H122.182V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.182 88.418H119.637V90.9441H122.182V88.418Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.182 85.8945H119.637V88.4206H122.182V85.8945Z",
    fill: "#C60018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.182 83.3672H119.637V85.8933H122.182V83.3672Z",
    fill: "#C60018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.635 90.9453H117.09V93.4722H119.635V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.635 88.418H117.09V90.9441H119.635V88.418Z",
    fill: "#E51727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.635 85.8945H117.09V88.4206H119.635V85.8945Z",
    fill: "#C60018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.635 83.3672H117.09V85.8933H119.635V83.3672Z",
    fill: "#C60018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.092 90.9453H114.547V93.4722H117.092V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.092 88.418H114.547V90.9441H117.092V88.418Z",
    fill: "#C60018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.092 85.8945H114.547V88.4206H117.092V85.8945Z",
    fill: "#C60018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.092 83.3672H114.547V85.8933H117.092V83.3672Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.092 80.8398H114.547V83.3667H117.092V80.8398Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.546 90.9453H112V93.4722H114.546V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.546 88.418H112V90.9441H114.546V88.418Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.546 85.8945H112V88.4206H114.546V85.8945Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.546 83.3672H112V85.8933H114.546V83.3672Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.546 80.8398H112V83.3667H114.546V80.8398Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.546 78.3125H112V80.8386H114.546V78.3125Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.998 90.9453H109.453V93.4722H111.998V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.998 88.418H109.453V90.9441H111.998V88.418Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.998 85.8945H109.453V88.4206H111.998V85.8945Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.998 83.3672H109.453V85.8933H111.998V83.3672Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.998 80.8398H109.453V83.3667H111.998V80.8398Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.998 78.3125H109.453V80.8386H111.998V78.3125Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.455 90.9453H106.91V93.4722H109.455V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.455 88.418H106.91V90.9441H109.455V88.418Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.455 85.8945H106.91V88.4206H109.455V85.8945Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.455 83.3672H106.91V85.8933H109.455V83.3672Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.455 80.8398H106.91V83.3667H109.455V80.8398Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.455 78.3125H106.91V80.8386H109.455V78.3125Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.909 90.9453H104.363V93.4722H106.909V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.909 88.418H104.363V90.9441H106.909V88.418Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.909 85.8945H104.363V88.4206H106.909V85.8945Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.909 83.3672H104.363V85.8933H106.909V83.3672Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.909 80.8398H104.363V83.3667H106.909V80.8398Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.909 78.3125H104.363V80.8386H106.909V78.3125Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.362 90.9453H101.816V93.4722H104.362V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.362 88.418H101.816V90.9441H104.362V88.418Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.362 85.8945H101.816V88.4206H104.362V85.8945Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.362 83.3672H101.816V85.8933H104.362V83.3672Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.362 80.8398H101.816V83.3667H104.362V80.8398Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.362 78.3125H101.816V80.8386H104.362V78.3125Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.362 75.7891H101.816V78.3152H104.362V75.7891Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.362 73.2617H101.816V75.7878H104.362V73.2617Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.819 90.9453H99.2734V93.4722H101.819V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.819 88.418H99.2734V90.9441H101.819V88.418Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.819 85.8945H99.2734V88.4206H101.819V85.8945Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.819 83.3672H99.2734V85.8933H101.819V83.3672Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2718 90.9453H96.7266V93.4722H99.2718V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2718 88.418H96.7266V90.9441H99.2718V88.418Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7288 90.9453H94.1836V93.4722H96.7288V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1827 90.9453H91.6367V93.4722H94.1827V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6351 90.9453H89.0898V93.4722H91.6351V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 90.9453H86.5469V93.4722H89.0921V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5453 90.9453H84V93.4722H86.5453V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9992 90.9453H81.4531V93.4722H83.9992V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4554 90.9453H78.9102V93.4722H81.4554V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9085 90.9453H76.3633V93.4722H78.9085V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3624 90.9453H73.8164V93.4722H76.3624V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 90.9453H66.1836V93.4722H68.7288V90.9453Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7288 85.8945H66.1836V88.4206H68.7288V85.8945Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 90.9453H63.6367V93.4722H66.1827V90.9453Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1827 88.418H63.6367V90.9441H66.1827V88.418Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6351 90.9453H61.0898V93.4722H63.6351V90.9453Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6351 88.418H61.0898V90.9441H63.6351V88.418Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 90.9453H58.5469V93.4722H61.0921V90.9453Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 88.418H58.5469V90.9441H61.0921V88.418Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 85.8945H58.5469V88.4206H61.0921V85.8945Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0921 83.3672H58.5469V85.8933H61.0921V83.3672Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 90.9453H56V93.4722H58.5453V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 88.418H56V90.9441H58.5453V88.418Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 85.8945H56V88.4206H58.5453V85.8945Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 83.3672H56V85.8933H58.5453V83.3672Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 80.8398H56V83.3667H58.5453V80.8398Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9992 90.9453H53.4531V93.4722H55.9992V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9992 88.418H53.4531V90.9441H55.9992V88.418Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9992 85.8945H53.4531V88.4206H55.9992V85.8945Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9992 83.3672H53.4531V85.8933H55.9992V83.3672Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4554 90.9453H50.9102V93.4722H53.4554V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4554 88.418H50.9102V90.9441H53.4554V88.418Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4554 85.8945H50.9102V88.4206H53.4554V85.8945Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9085 90.9453H48.3633V93.4722H50.9085V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9085 88.418H48.3633V90.9441H50.9085V88.418Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9085 85.8945H48.3633V88.4206H50.9085V85.8945Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3656 90.9453H45.8203V93.4722H48.3656V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3656 88.418H45.8203V90.9441H48.3656V88.418Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8195 90.9453H43.2734V93.4722H45.8195V90.9453Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8195 88.418H43.2734V90.9441H45.8195V88.418Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8195 85.8945H43.2734V88.4206H45.8195V85.8945Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8195 83.3672H43.2734V85.8933H45.8195V83.3672Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8195 80.8398H43.2734V83.3667H45.8195V80.8398Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8195 78.3125H43.2734V80.8386H45.8195V78.3125Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2718 90.9453H40.7266V93.4722H43.2718V90.9453Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2718 88.418H40.7266V90.9441H43.2718V88.418Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2718 85.8945H40.7266V88.4206H43.2718V85.8945Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2718 83.3672H40.7266V85.8933H43.2718V83.3672Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2718 80.8398H40.7266V83.3667H43.2718V80.8398Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2718 78.3125H40.7266V80.8386H43.2718V78.3125Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2718 75.7891H40.7266V78.3152H43.2718V75.7891Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7288 90.9453H38.1836V93.4722H40.7288V90.9453Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7288 88.418H38.1836V90.9441H40.7288V88.418Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7288 85.8945H38.1836V88.4206H40.7288V85.8945Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7288 83.3672H38.1836V85.8933H40.7288V83.3672Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7288 80.8398H38.1836V83.3667H40.7288V80.8398Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7288 78.3125H38.1836V80.8386H40.7288V78.3125Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7288 75.7891H38.1836V78.3152H40.7288V75.7891Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.182 90.9453H35.6367V93.4722H38.182V90.9453Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.182 88.418H35.6367V90.9441H38.182V88.418Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.182 85.8945H35.6367V88.4206H38.182V85.8945Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.182 83.3672H35.6367V85.8933H38.182V83.3672Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.182 80.8398H35.6367V83.3667H38.182V80.8398Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.182 78.3125H35.6367V80.8386H38.182V78.3125Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.182 75.7891H35.6367V78.3152H38.182V75.7891Z",
    fill: "#6F6FE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6359 90.9453H33.0898V93.4722H35.6359V90.9453Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6359 88.418H33.0898V90.9441H35.6359V88.418Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6359 85.8945H33.0898V88.4206H35.6359V85.8945Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6359 83.3672H33.0898V85.8933H35.6359V83.3672Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6359 80.8398H33.0898V83.3667H35.6359V80.8398Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6359 78.3125H33.0898V80.8386H35.6359V78.3125Z",
    fill: "#8C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6359 75.7891H33.0898V78.3152H35.6359V75.7891Z",
    fill: "#6F6FE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0921 90.9453H30.5469V93.4722H33.0921V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0921 88.418H30.5469V90.9441H33.0921V88.418Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0921 85.8945H30.5469V88.4206H33.0921V85.8945Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0921 83.3672H30.5469V85.8933H33.0921V83.3672Z",
    fill: "#6F6FE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0921 80.8398H30.5469V83.3667H33.0921V80.8398Z",
    fill: "#6F6FE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0921 78.3125H30.5469V80.8386H33.0921V78.3125Z",
    fill: "#6F6FE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5453 90.9453H28V93.4722H30.5453V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5453 88.418H28V90.9441H30.5453V88.418Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5453 85.8945H28V88.4206H30.5453V85.8945Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0023 90.9453H25.457V93.4722H28.0023V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0023 88.418H25.457V90.9441H28.0023V88.418Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0023 85.8945H25.457V88.4206H28.0023V85.8945Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4562 90.9453H22.9102V93.4722H25.4562V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4562 88.418H22.9102V90.9441H25.4562V88.418Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4562 85.8945H22.9102V88.4206H25.4562V85.8945Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9085 90.9453H20.3633V93.4722H22.9085V90.9453Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9085 88.418H20.3633V90.9441H22.9085V88.418Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3656 90.9453H17.8203V93.4722H20.3656V90.9453Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8187 90.9453H15.2734V93.4722H17.8187V90.9453Z",
    fill: "#D3DDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.545 75.7891H140V78.3152H142.545V75.7891Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.545 73.2617H140V75.7878H142.545V73.2617Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.998 75.7891H137.453V78.3152H139.998V75.7891Z",
    fill: "#FEF8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.998 73.2617H137.453V75.7878H139.998V73.2617Z",
    fill: "#FEF8EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_901_6009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 96,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNySnowman);
export default __webpack_public_path__ + "static/media/NY-snowman.183a4a8531d73303dbd3234ab1ac7680.svg";
export { ForwardRef as ReactComponent };